import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import CardSelector from '../CardSelector';
import withValidation from '../../containers/withValidation';
import { toAccountPropType } from '../../states/accounts/propTypes';
import payeePropTypes from '../../states/payees/propTypes';
import withDescription from '../../containers/withDescription';
import { getSelectedAccount } from '../../states/accounts/selectors';

class ToAccount extends Component {
	render() {
		const {
			id,
			toAccount,
			fromAccount,
			toAccounts,
			toPayees,
			handleCardClick,
			showAccountSelector,
			disable,
			rawPayment,
			title,
		} = this.props;
		return (
			<div className="c-o-list-payment__input-wrap">
				<div className="c-m-payment-control">
					<div
						className={classNames({
							'c-m-payment-control__field': true,
							'c-m-payment-control__field--is-active': showAccountSelector,
							'c-m-payment-control__field--is-disabled': !fromAccount,
						})}
					>
						<CardSelector
							id={`field-to-account-${id}`}
							title={title}
							iconType="PlusOutlineLarge"
							onClick={() => {
								handleCardClick(id, toAccount);
							}}
							disabled={disable}
							selectedAccount={getSelectedAccount(toAccounts, toPayees, toAccount, get(rawPayment, 'toAccount'))}
						/>
					</div>
				</div>
			</div>
		);
	}
}
ToAccount.defaultProps = {
	title: 'from',
};

ToAccount.defaultProps = {
	fromAccount: '',
	toAccounts: [],
	title: 'To',
};

ToAccount.propTypes = {
	toAccount: PropTypes.string,
	handleCardClick: PropTypes.func.isRequired,
	fromAccount: PropTypes.string.isRequired,
	showAccountSelector: PropTypes.bool,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(toAccountPropType)),
	id: PropTypes.string.isRequired,
	disable: PropTypes.bool,
	rawPayment: PropTypes.shape({}),
	title: PropTypes.string,
};

export { ToAccount };
export const SourceAccount = withValidation({
	validations: ['required'],
	key: 'toAccount',
	message: 'Select an account or payee to collect money from.',
})(withDescription(ToAccount));

export default withValidation({
	validations: ['required'],
	key: 'toAccount',
	message: 'Select an account or payee to move your money to.',
})(withDescription(ToAccount));
